import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import { findByNome, findByCodigo, findAlunoByUsuarioEmail } from "./api-aluno";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import Loading from "../UI/Loading";

const BUSCAS = [
  { value: "nome", label: "Nome", request: findByNome },
  { value: "codigo", label: "Código", request: findByCodigo },
  { value: "email", label: "E-mail", request: findAlunoByUsuarioEmail },
];

const toList = (data) => (Array.isArray(data) ? data : data?.codigo ? [data] : []);

export default function AlunoFindDialog({ openSearch, setOpenSearch, setAluno }) {
  const [alunos, setAlunos] = useState(null);
  const [por, setPor] = useState("nome");
  const [busca, setBusca] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const clickSubmit = (event) => {
    event.preventDefault();
    const valor = busca.trim();
    if (!valor) return;
    const { request } = BUSCAS.find((b) => b.value === por);
    setIsLoading(true);
    request(valor)
      .then((data) => {
        if (data?.error) {
          errorMessage(data.message);
          return;
        }
        setAlunos(toList(data));
      })
      .finally(() => setIsLoading(false));
  };

  const handlePorChange = (event) => {
    setPor(event.target.value);
    setBusca("");
    setAlunos(null);
  };

  const handleSelectedAluno = (aluno) => {
    setAluno(aluno);
    setOpenSearch(false);
  };

  const renderResults = () => {
    if (isLoading) {
      return (
        <Box py={4}>
          <Loading size={28} description="Buscando alunos..." />
        </Box>
      );
    }
    if (alunos === null) return null;
    if (alunos.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" textAlign="center" py={4}>
          Nenhum aluno encontrado.
        </Typography>
      );
    }
    return (
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2, maxHeight: 360 }}>
        <Table size="small" stickyHeader aria-label="Resultado da busca de alunos">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600 } }}>
              <TableCell sx={{ width: 110 }}>Código</TableCell>
              <TableCell>Nome</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alunos.map((aluno) => (
              <TableRow key={aluno.codigo} hover onClick={() => handleSelectedAluno(aluno)} sx={{ cursor: "pointer" }}>
                <TableCell>{aluno.codAlunoEscola || "--"}</TableCell>
                <TableCell>{aluno.nome}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Dialog
      open={Boolean(openSearch)}
      onClose={() => setOpenSearch(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="aluno-find-dialog-title"
    >
      <DialogTitle id="aluno-find-dialog-title">Procurar Aluno</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <form onSubmit={clickSubmit}>
            <Stack spacing={1.5}>
              <RadioGroup row value={por} onChange={handlePorChange} aria-label="Buscar por">
                {BUSCAS.map((b) => (
                  <FormControlLabel key={b.value} value={b.value} control={<Radio size="small" />} label={b.label} />
                ))}
              </RadioGroup>
              <Stack direction="row" spacing={1}>
                <TextField
                  size="small"
                  fullWidth
                  autoFocus
                  label={BUSCAS.find((b) => b.value === por).label}
                  value={busca}
                  onChange={(event) => setBusca(event.target.value)}
                />
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  disabled={isLoading || !busca.trim()}
                  sx={{ flexShrink: 0 }}
                >
                  Buscar
                </Button>
              </Stack>
            </Stack>
          </form>
          {renderResults()}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenSearch(false)}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
